import axios from 'axios'
import storage                              from 'good-storage';
import http from '@/axios/http'
import Vue from 'vue'
import Vuex from 'vuex'
import CBCCrypto from '@/util/CBCCrypto';
import {LoginService} from "@/service/index";
import router from "../../router";


Vue.use(Vuex)

const AUTHORIZATION = 'Authorization';

const state = {
    //
    userInfo: {},
    roles:{},
    params: {},
    token: '' || storage.session.get(AUTHORIZATION)
};

const mutations = {
    updateParams(state, payload) {
        state.params = payload;
    },
    SET_TOKEN: (state, token) => {
        state.token = token;
    },
    updateUserInfo(state, payload) {
        state.userInfo = payload;
        storage.session.set("userInfo", payload);
        storage.session.set("factoryCode", payload.firstFactoryCode || "");
        this.commit('common/SET_FACTORY_CODE', payload.firstFactoryCode || "");
    },
    updateRoles(state, payload) {
        state.roles = payload;
        storage.session.set("roles", payload);
    },
};

const getters = {
    userInfo: state => state.userInfo,
    roles: state => state.roles,
    params: state => state.params,

};

const actions = {
    fetchParams({commit, state}, payload) {
        commit('updateParams', payload)
    },


    login({dispatch, commit}, userInfo) {
        const _this = this;
        const timestamp = new Date().getTime().toString();
        let ps = userInfo.password;
        // 登录密码,二次加密,如果需要关闭此功能,请注释下面一行代码. 同时后台接口需要做相应修改.
        ps = CBCCrypto.encrypt(userInfo.password, timestamp, timestamp);
        userInfo.password = ps;
        userInfo.timestamp = timestamp;
        return new Promise((resolve, reject) => {
            LoginService.doLogin(userInfo).then(response => {
                if (response.success) {
                    console.log(response.data.token);
                    //debugger;
                    let data = response.data;
                    let token = data.token;
                    commit('SET_TOKEN', token);
                    storage.session.set(AUTHORIZATION, token);
                    commit('updateUserInfo', data.userInfo);
                    commit('updateRoles', data.roles);
                    dispatch('menu/dynamicMenu', data.menus, {root: true});
                }
                resolve(response);
                resolve({
                    success: true,
                    message: 'success'
                });
            }).catch(error => {
                reject(error);
            })

        })
    },
    /**
     * 登出注销接口
     * @param dispathc
     * @param commit
     * @returns {Q.Promise<any> | * | Promise<T>}
     */
    logout({dispatch, commit}) {
        const _this = this;
        return new Promise((resolve, reject) => {
            http.post('/logout').then(response => {
                // do someting；
            });
            dispatch('menu/clearStatus', [], {root: true});
            storage.clear();
            storage.session.clear();
            resolve();
        }).catch(e => {
            reject(e);
        })
    }

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/userInfo.js